"use client";

import { useTheme } from "next-themes";
import Image from "next/image";
import { useEffect, useState } from "react";

interface CounterDisplayProps {
  count: number | null;
  label?: string;
}

export const CounterDisplay = ({ count, label = "games scored" }: CounterDisplayProps) => {
  const { resolvedTheme } = useTheme();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setMounted(true);
  }, []);

  if (count === null) {
    return <div className="animate-pulse h-20 w-32 bg-surfaceContainer/50 rounded-lg"></div>;
  }

  // Add a leading zero to the count string
  const countStr = "0" + count.toString();
  const digits = countStr.split("");

  // Determine path based on theme
  // Default to public/drawables (light) if theme is not resolved yet or is light
  // Use public/drawables_night if theme is dark
  const basePath = mounted && resolvedTheme === "dark" ? "/drawables_night" : "/drawables";

  return (
    <div className="flex flex-col items-center">
      <div className="flex items-center gap-0.5">
        {digits.map((digit, index) => (
          <div key={index} className="relative w-6 h-8 md:w-6 md:h-8">
            <Image
              src={`${basePath}/icon_counter_digit${digit}.png`}
              alt={`Digit ${digit}`}
              fill
              className="object-contain"
              priority // Load these quickly as they are key content
              unoptimized
            />
          </div>
        ))}
      </div>
      <p className="text-xs md:text-sm text-[#C4C8BA] mt-1">{label}</p>
    </div>
  );
};
